import axios from "axios";

export default axios.create({
  baseURL:
    process.env.NODE_ENV === "production"
      ? "https://app.fishesoccer.com"
      : "http://localhost:4000",
});
